module.exports = __webpack_public_path__ + "img/trial-user-label.176f86ba.png";